/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import "./src/styles/normalize.scss"
import "./src/styles/skeleton.scss"
import "typeface-fjalla-one";

// GA4 page views on client-side navigation (the initial load is counted by gtag's config call).
export const onRouteUpdate = ({ location, prevLocation }) => {
  if (!prevLocation || typeof window.gtag !== "function") return
  window.gtag("event", "page_view", { page_path: location.pathname })
}
